import type { InvoiceInterface } from "@finway-group/shared/lib/models"

/** True until the generated self-issued receipt file is attached. Manually uploaded invoices do not count. */
export const isAwaitingGeneratedSelfIssuedReceipt = ({
    isSelfIssuedReceipt,
    invoices,
}: {
    isSelfIssuedReceipt?: boolean
    invoices: Array<Pick<InvoiceInterface, "isSelfIssued">>
}) => Boolean(isSelfIssuedReceipt) && invoices.every((invoice) => !invoice.isSelfIssued)

/**
 * The empty upload area can show the generation animation only when the expense has no documents yet.
 * Once a manual document is attached, the same animation needs the "New Document" tab the + button would open.
 */
export const shouldOpenPendingGeneratedReceiptTab = ({
    isAwaitingGeneratedReceipt,
    attachedDocumentCount,
}: {
    isAwaitingGeneratedReceipt: boolean
    attachedDocumentCount: number
}) => isAwaitingGeneratedReceipt && attachedDocumentCount > 0

export const appendPendingGeneratedReceiptTab = <TTab>({
    tabs,
    pendingTab,
    shouldOpenPendingTab,
}: {
    tabs: Array<TTab>
    pendingTab: TTab
    shouldOpenPendingTab: boolean
}): Array<TTab> => (shouldOpenPendingTab ? [...tabs, pendingTab] : tabs)
